export function emptyFunc() {
  return;
}

export function convertToCurrency(number: number): string {
  return `Rp. ${number.toLocaleString("id")}`;
}
